// extracted by mini-css-extract-plugin
export var required = "_ge-0";